import type { CatalogueEntry } from "../types";
import imageLight from "../images/building-solar.light.webp";
import imageDark from "../images/building-solar.dark.webp";

export const entry: CatalogueEntry = {
  slug: "building-solar",
  displayName: `Building Solar`,
  datasetProductCode: `BUILDING-SOLAR`,
  subtitle: `Solar Presence, Area and Estimated Power for Australian Buildings`,
  shortDescription: `The Building Solar Insight Pack is a national digital dataset representing solar information at the building level across all Australian states and territories. It includes a solar presence flag, the combined area of solar arrays, and the daily estimated power those arrays generate.
Building Solar is an insight pack that extends the National Buildings product. Each record links 1:1 to a building in the Buildings product through the building_pid, so solar insights can be joined directly to building footprints and their related property, cadastre and address data.`,
  metadata: {
    dateAdded: 1787270400000,
    dataType: ["Aspatial"],
    totalFeatureCount: 19073783,
    updateFrequency: `Quarterly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/projects/building_solar_insight_pack/en/stable/index.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/building_solar_insight_pack/en/stable/index.html`,
  imageLight,
  imageDark,
  searchTags: `Building Solar National Buildings Insight Pack Solar Panels Photovoltaic Solar Area Estimated Power Renewable Energy Net Zero Net-zero Grid Network Planning Property Insights Aerial Imagery Geoscape Buildings Solar`,
  detail: () => import("../details/building-solar").then((m) => m.detail),
};

export default entry;
